/**
 * @module Tooltip
 */

import tippy from 'tippy.js';
import Component from '../Component';
import './tippy.css';
import './styles.css';

/**
 * Тултип и дропдаун.
 *
 * Использует плагин tippy.js.
 * Для прямого доступа к функционалу плагина используется поле instance.
 *
 * @see {@link https://atomiks.github.io/tippyjs/}
 *
 * @todo Не применяется стилизация к содержимому дропдаунов.
 */
export default class Tooltip extends Component {
    static className = 'tooltip';

    initElements() {
        this.elements = {
            $trigger: $('.tooltip__trigger', this.$block),
        };
    }

    setProperties({ type, content, template, theme, animation, placement, click }) {
        /**
         * Тип компонента.
         * @type {string}
         */
        this.type = type;

        /**
         * Текст тултипа.
         * @type {string}
         */
        this.content = content;

        /**
         * Имя шаблона.
         * @type {string}
         */
        this.template = template;

        /**
         * Имя темы.
         * @type {string}
         */
        this.theme = theme;

        /**
         * Тип анимации.
         * @type {string}
         */
        this.animation = animation;

        /**
         * Позиционирование.
         * @type {string}
         */
        this.placement = placement;

        /**
         * Позиционирование.
         * @type {string}
         */
        this.placement = placement;

        /**
         * Триггер на клик.
         * @type {boolean}
         */
        this.click = click;

        /**
         * Настройки плагина.
         * @type {Object}
         */
        this.options = {
            arrow: true,
            ignoreAttributes: true,
        };

        if (theme) {
            this.options.theme = theme;
        } else {
            this.options.theme = type === 'tooltip' ? 'tooltip' : 'dropdown';
        }

        if (animation) {
            this.options.animation = animation;
        } else {
            this.options.animation = type === 'tooltip' ? 'shift-away' : 'fade';
        }

        if (placement) {
            this.options.placement = placement;
        }

        if (click) {
            this.options.trigger = 'click';
        }

        /* Расширяем список настроек дефолтными настройками тултипов или дропдаунов (в зависимости от type). */
        if (this.type === 'tooltip') {
            Object.assign(this.options, {
                allowHTML: false,
                content: this.content,
                inertia: true,
            });
        } else {
            Object.assign(this.options, {
                /* Дропдаун всегда размещается сразу после кнопки и тем самым становится доступен для прохождения табом. */
                appendTo: ref => ref.parentNode,
                content: template,
                interactive: true,
                interactiveBorder: 50,
            });
        }
    }

    initPlugin(pluginOptions) {
        /* Переопределяем настройки настройками, переданными напрямую через Create(). */
        Object.assign(this.options, pluginOptions);

        /* Скрытие на клик отключается кроме случаев, когда задан триггер через клик. */
        if (this.options.trigger !== 'click') {
            this.options.hideOnClick = false;
        }

        /**
         * Объект для доступа к функционалу плагина.
         * @type {Object}
         */
        this.instance = tippy(this.elements.$trigger[0], this.options);
    }
}
